import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { theme } from './theme';
import { queryClient } from './lib/queryClient';
import { ConfirmProvider } from './components/feedback/ConfirmDialog';
import ErrorBoundary from './components/feedback/ErrorBoundary';
import ToastHost from './components/feedback/ToastHost';
import { AuthProvider } from './auth/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <ConfirmProvider>
                    <BrowserRouter>
                        <AuthProvider>
                            <ErrorBoundary>
                                <App />
                            </ErrorBoundary>
                        </AuthProvider>
                    </BrowserRouter>
                    <ToastHost />
                </ConfirmProvider>
            </QueryClientProvider>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
